import { useEffect, useMemo, useState } from "react";
import { useViewActivityQuery } from "../../hooks/dashboard/activity.view.all";
import { formatRelativeTime, mapActivityItems } from "../../utils/mapDashboardActivity";
import { usePagination } from "./pagination";
import Pagination from "./pagination";
import "../../assets/styles/cards.css";

const ITEMS_PER_PAGE = 7;
const TIME_REFRESH_MS = 60000;

export default function RecentActivity({
  activities: propActivities,
  title = "Recent Activity",
  itemsPerPage = ITEMS_PER_PAGE,
}) {
  const fetchFromApi = propActivities == null;
  const [now, setNow] = useState(Date.now());

  const { data: fetchedData, isLoading, isError } = useViewActivityQuery({
    enabled: fetchFromApi,
  });

  const activities = useMemo(() => {
    if (propActivities) return propActivities;
    return mapActivityItems(fetchedData);
  }, [propActivities, fetchedData]);

  const displayActivities = useMemo(() => {
    return activities.map((item) => ({
      ...item,
      time: item.createdAt
        ? formatRelativeTime(item.createdAt)
        : item.time || "-",
    }));
  }, [activities, now]);

  const { currentItems, totalPages, currentPage, handlePageChange } =
    usePagination(displayActivities, itemsPerPage);

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), TIME_REFRESH_MS);
    return () => clearInterval(interval);
  }, []);

  if (fetchFromApi && isLoading) {
    return (
      <div className="activity-card chart-loading">Loading recent activity...</div>
    );
  }

  if (fetchFromApi && isError) {
    return (
      <div className="activity-card chart-error">
        Could not load recent activity.
      </div>
    );
  }

  if (!activities.length) {
    return (
      <div className="activity-card chart-empty">
        <h3 className="activity-title">{title}</h3>
        <p className="activity-empty-text">No recent activity found.</p>
      </div>
    );
  }

  return (
    <div className="activity-card">
      <h3 className="activity-title">{title}</h3>

      <div className="activity-list">
        {currentItems.map((item) => (
          <div key={item.id} className="activity-item">
            <div className="activity-item-left">
              <span className="activity-bullet" aria-hidden="true" />
              <div className="activity-content">
                <p className="activity-action">{item.action}</p>
                <p className="activity-description">{item.description}</p>
              </div>
            </div>
            <p className="activity-time">{item.time}</p>
          </div>
        ))}
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
}
